import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import BoxSleeve from "./see/BoxSleeve";


export default function ProductList({ adors, session, products, setActiveProduct }) {

  const handleImageError = (e) => {
    e.stopPropagation();
    e.target.src = '/sees/dist/img/noimages.png';
  };

  useEffect(() => {

  }, []);


  // Only See's candies
  if (session.pcid == 2218) {
    return (<BoxSleeve adors={adors} session={session} products={products} setActiveProduct={setActiveProduct} />);
  }
  else {
    return (
      <>
        <div className="row mt-2 justify-content-center col-lg-12">
          <div className="col-lg-12">
            <h2 className="text-center">Box Sleeve</h2>
          </div>
        </div>

        <div className="row mb-2 justify-content-center col-lg-12">
          {products.map((product, index) => (
            <div className="col-3 border me-2" key={index}>
              <div className="row">
                <div className="col-6">
                  <img
                    src={"/sees/dist/img/product/sample.jpg"}
                    className="img-fluid"
                    onError={handleImageError}
                    onClick={() => setActiveProduct(product.id)}
                  />
                </div>
                <div className="col-6 my-auto">
                  <span>{product.name}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    )
  }
}

